import { sendReviewFeedback } from 'apis/registerResult';
import { useMutation } from 'react-query';

const useSendReviewFeedback = () => useMutation(sendReviewFeedback);

export default useSendReviewFeedback;
